// extracted by mini-css-extract-plugin
export default {"container":"S02_container__9cEMv","headline":"S02_headline__QnC4W","wrapper":"S02_wrapper__BROQl","box":"S02_box__JmdIC","title":"S02_title__WKkwm"};